var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "manager-container" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c(
              "router-link",
              {
                staticClass: "sub-heading",
                attrs: { to: "/layout/launchpad" },
              },
              [
                _c("i", { staticClass: "fa fa-angle-left" }),
                _vm._v("Add Project Manager "),
              ]
            ),
            _c(
              "div",
              { staticClass: "row m-0 mt-25", attrs: { id: "manageTeam" } },
              [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" },
                  [
                    _c("div", { staticClass: "col-xs-12 search p-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.enteredAccountName,
                            expression: "enteredAccountName",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass:
                          "search-input form-control dropdown-toggle",
                        attrs: {
                          type: "text",
                          placeholder: "Account Name",
                          "data-toggle": "dropdown",
                        },
                        domProps: { value: _vm.enteredAccountName },
                        on: {
                          keyup: function ($event) {
                            _vm.loadedUser = true
                            _vm.getAccountsListForAccountSearch()
                          },
                          focus: function ($event) {
                            _vm.loadedUser = true
                            _vm.getAccountsListForAccountSearch()
                          },
                          change: _vm.validateAccount,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.enteredAccountName = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm.enteredAccountName
                        ? _c(
                            "span",
                            {
                              staticClass: "search-reset reset-close-xs",
                              on: {
                                click: function ($event) {
                                  return _vm.setAccountFieldValues()
                                },
                              },
                            },
                            [
                              _c("base-icon", {
                                staticClass: "icon-close",
                                attrs: { icon: "close_icon" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.enteredAccountName.length > 1 && !_vm.loadedUser
                        ? _c(
                            "div",
                            { staticClass: "col-xs-12 dropdown-menu" },
                            [
                              _vm.accountList.length
                                ? _c(
                                    "ul",
                                    _vm._l(
                                      _vm.accountList,
                                      function (account, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            on: {
                                              click: function ($event) {
                                                return _vm.setAccountFieldValues(
                                                  account
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(account.account_name)
                                              ),
                                            ]),
                                            _c(
                                              "span",
                                              { staticClass: "float-rt" },
                                              [
                                                _vm._v(
                                                  _vm._s(account.account_id)
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("ul", { staticClass: "col-xs-12 p-0" }, [
                                    _c(
                                      "li",
                                      { staticClass: "bg-smoke-white" },
                                      [_vm._v("No Accounts available.")]
                                    ),
                                  ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "col-xs-12 p-0" }, [
                      _vm.enteredAccountName &&
                      _vm.enteredAccountName.length < 2
                        ? _c("div", { staticClass: "bg-smoke-red" }, [
                            _vm._v(
                              " Please enter at least 2 characters for account name. "
                            ),
                          ])
                        : !_vm.validAccount
                        ? _c("div", { staticClass: "bg-smoke-red" }, [
                            _vm._v("Please select an account."),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.roleName,
                          expression: "roleName",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", readonly: "" },
                      domProps: { value: _vm.roleName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.roleName = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" },
                  [
                    _c("div", { staticClass: "col-xs-12 search p-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.projectManager.first_name,
                            expression: "projectManager.first_name",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass:
                          "search-input form-control dropdown-toggle",
                        attrs: {
                          type: "text",
                          placeholder: "First Name",
                          maxlength: "35",
                          "data-toggle": "dropdown",
                        },
                        domProps: { value: _vm.projectManager.first_name },
                        on: {
                          keyup: function ($event) {
                            _vm.loadedUser = true
                            _vm.getusersListForUserSearch(
                              _vm.projectManager.first_name,
                              "first_name"
                            )
                          },
                          focusin: function ($event) {
                            _vm.loadedUser = true
                            _vm.getusersListForUserSearch(
                              _vm.projectManager.first_name,
                              "first_name"
                            )
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.projectManager,
                              "first_name",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm.projectManager.first_name.length > 1 &&
                      !_vm.loadedUser
                        ? _c(
                            "div",
                            { staticClass: "col-xs-12 dropdown-menu" },
                            [
                              _c(
                                "div",
                                { staticClass: "list" },
                                [
                                  _vm.userList.length
                                    ? _vm._l(
                                        _vm.userList,
                                        function (user, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "list-items d-flex flex-between align-items-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setUserFiledvalues(
                                                    user
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(user.first_name) +
                                                      " " +
                                                      _vm._s(user.last_name)
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  { staticClass: "email" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(user.email_id)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/images/icons/check.svg",
                                                  alt: "check-icon",
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ft-16 text-emergo-dark-blue text-center",
                                        },
                                        [_vm._v(" No Users available. ")]
                                      ),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "col-xs-12 p-0" }, [
                      _vm.projectManager.first_name &&
                      _vm.projectManager.first_name.length < 2
                        ? _c("div", { staticClass: "bg-smoke-red" }, [
                            _vm._v(
                              " Please enter at least 2 characters for first name. "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._m(3),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" },
                  [
                    _c("div", { staticClass: "col-xs-12 search p-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.projectManager.last_name,
                            expression: "projectManager.last_name",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass:
                          "search-input form-control dropdown-toggle",
                        attrs: {
                          type: "text",
                          placeholder: "Last Name",
                          maxlength: "35",
                          "data-toggle": "dropdown",
                        },
                        domProps: { value: _vm.projectManager.last_name },
                        on: {
                          keyup: function ($event) {
                            _vm.loadedUser = true
                            _vm.getusersListForUserSearch(
                              _vm.projectManager.last_name,
                              "last_name"
                            )
                          },
                          focusin: function ($event) {
                            _vm.loadedUser = true
                            _vm.getusersListForUserSearch(
                              _vm.projectManager.last_name,
                              "last_name"
                            )
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.projectManager,
                              "last_name",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm.projectManager.last_name.length > 1 && !_vm.loadedUser
                        ? _c(
                            "div",
                            { staticClass: "col-xs-12 dropdown-menu" },
                            [
                              _c(
                                "div",
                                { staticClass: "list" },
                                [
                                  _vm.userList.length
                                    ? _vm._l(
                                        _vm.userList,
                                        function (user, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "list-items d-flex flex-between align-items-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setUserFiledvalues(
                                                    user
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(user.first_name) +
                                                      " " +
                                                      _vm._s(user.last_name)
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  { staticClass: "email" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(user.email_id)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/images/icons/check.svg",
                                                  alt: "check-icon",
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ft-16 text-emergo-dark-blue text-center",
                                        },
                                        [_vm._v(" No Users available. ")]
                                      ),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "col-xs-12 p-0" }, [
                      _vm.projectManager.last_name &&
                      _vm.projectManager.last_name.length < 2
                        ? _c("div", { staticClass: "bg-smoke-red" }, [
                            _vm._v(
                              " Please enter at least 2 characters for last name. "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._m(4),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-8 col-md-6 mb-25" },
                  [
                    _c("div", { staticClass: "col-xs-12 search p-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.projectManager.email,
                            expression: "projectManager.email",
                          },
                        ],
                        staticClass:
                          "search-input form-control dropdown-toggle",
                        attrs: {
                          type: "text",
                          placeholder: "Email",
                          maxlength: "65",
                          "data-toggle": "dropdown",
                        },
                        domProps: { value: _vm.projectManager.email },
                        on: {
                          keyup: function ($event) {
                            _vm.loadedUser = true
                            _vm.getusersListForUserSearch(
                              _vm.projectManager.email,
                              "email"
                            )
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.projectManager,
                              "email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm.projectManager.email.length > 1
                        ? _c(
                            "div",
                            { staticClass: "col-xs-12 dropdown-menu" },
                            [
                              _c(
                                "div",
                                { staticClass: "list" },
                                [
                                  _vm.userList.length
                                    ? _vm._l(
                                        _vm.userList,
                                        function (user, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "list-items d-flex flex-between align-items-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setUserFiledvalues(
                                                    user
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(user.first_name) +
                                                      " " +
                                                      _vm._s(user.last_name)
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  { staticClass: "email" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(user.email_id)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/images/icons/check.svg",
                                                  alt: "check-icon",
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ft-16 text-emergo-dark-blue text-center",
                                        },
                                        [_vm._v(" No Users available. ")]
                                      ),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "col-xs-12 p-0 err-container" }, [
                      _vm.projectManager.email &&
                      _vm.projectManager.email.length < 2
                        ? _c("div", { staticClass: "bg-smoke-red" }, [
                            _vm._v(
                              " Please enter at least 2 characters for email. "
                            ),
                          ])
                        : _vm._e(),
                      _vm.projectManager.email &&
                      _vm.projectManager.email.length > 1 &&
                      !_vm.validEmail
                        ? _c("div", { staticClass: "bg-smoke-red errorMsg" }, [
                            _vm._v(" Please enter a valid email address. "),
                          ])
                        : _vm._e(),
                      _vm.emailExists
                        ? _c("div", { staticClass: "bg-smoke-red errorMsg" }, [
                            _vm._v(
                              " Email already registered with the account. "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-offset-1 col-xs-10 col-sm-offset-6 col-sm-5 col-md-offset-6 col-md-5 col-lg-offset-8 col-lg-3",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.disableButtonForAddTeam || _vm.loaderStatus,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addprojectManager()
                          },
                        },
                      },
                      [_vm._v(" Save Changes ")]
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("p", [_vm._v("Account Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [_c("p", [_vm._v("Role")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("p", [_vm._v("First Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("p", [_vm._v("Last Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [_c("p", [_vm._v("Email")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }